import React from 'react';

function SizingSection({config,formData,updateFormData}) {
  const handleGarmentChange=(garmentType,size)=> {
    const newGarments={...formData.garments};
    newGarments[garmentType]=size;
    updateFormData({garments: newGarments});
  };

  const handlePantsLengthChange=(value)=> {
    updateFormData({pantsLength: value});
  };

  const getSizeOptions=(garment)=> {
    // Si la prenda es un string antiguo,usar valores por defecto
    if (typeof garment==='string') {
      if (garment==='CHALECO') {
        const sizes=[];
        for (let i=0;i <=7;i++) {
          sizes.push(i.toString());
        }
        return sizes;
      } else {
        // Para POLO y PANTALON,usar tallas americanas de XS a 6XL
        return ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
      }
    }
    
    // Si es un objeto con configuración,usar esa configuración
    if (garment.sizeType==='american') {
      const americanSizes=['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
      const startIndex=americanSizes.indexOf(garment.sizeRange.min);
      const endIndex=americanSizes.indexOf(garment.sizeRange.max);
      if (startIndex !==-1 && endIndex !==-1 && startIndex <=endIndex) {
        return americanSizes.slice(startIndex,endIndex + 1);
      }
      return americanSizes;
    } else if (garment.sizeType==='european') {
      const min=parseInt(garment.sizeRange.min) || 34;
      const max=parseInt(garment.sizeRange.max) || 58;
      const sizes=[];
      for (let i=min;i <=max;i +=2) {
        sizes.push(i.toString());
      }
      return sizes;
    } else if (garment.sizeType==='numeric') {
      const min=parseInt(garment.sizeRange.min) || 0;
      const max=parseInt(garment.sizeRange.max) || 7;
      const sizes=[];
      for (let i=min;i <=max;i++) {
        sizes.push(i.toString());
      }
      return sizes;
    }
    return [];
  };

  const getGarmentName=(garment)=> {
    return typeof garment==='string' ? garment : garment.name;
  };

  return (
    <div className="space-y-4">
      <div className="bg-yellow-100 p-2 sm:p-3 rounded">
        <h3 className="text-sm sm:text-lg font-semibold text-center">DATOS DE LAS TALLAS</h3>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-xs sm:text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2 sm:p-3 text-left font-semibold whitespace-nowrap w-3/4">
                VESTUARIO
              </th>
              <th className="border border-gray-300 p-2 sm:p-3 text-left font-semibold whitespace-nowrap w-1/4">
                TALLA
              </th>
            </tr>
          </thead>
          <tbody>
            {config.garmentTypes.map((garmentType,index)=> {
              const garmentName=getGarmentName(garmentType);
              const availableSizes=getSizeOptions(garmentType);
              return (
                <tr key={index}>
                  <td className="border border-gray-300 p-2 sm:p-3 font-medium whitespace-nowrap w-3/4">
                    <span className="block truncate" title={garmentName}>
                      {garmentName}
                    </span>
                  </td>
                  <td className="border border-gray-300 p-2 sm:p-3 w-1/4">
                    <div className="flex flex-col gap-1">
                      <select 
                        value={formData.garments[garmentName] || ''} 
                        onChange={(e)=> handleGarmentChange(garmentName,e.target.value)}
                        className="w-full p-1 sm:p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
                      >
                        <option value="">Seleccionar</option>
                        {availableSizes.map(size=> (
                          <option key={size} value={size}>{size}</option>
                        ))}
                      </select>
                      <input 
                        type="text" 
                        value={formData.garments[garmentName] || ''} 
                        onChange={(e)=> handleGarmentChange(garmentName,e.target.value)}
                        className="w-full p-1 sm:p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
                        placeholder="Talla"
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-3 sm:p-4 border border-gray-300 rounded">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            Largo Pantalón (en cm.)
          </label>
        </div>
        <div>
          <input 
            type="number" 
            value={formData.pantsLength} 
            onChange={(e)=> handlePantsLengthChange(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Longitud en cm"
          />
        </div>
      </div>
    </div>
  );
}

export default SizingSection;